module.exports = __webpack_public_path__ + "static/pancit-canton-b1524722eba5b01f9d4cb65061a8a048.jpg";